module.exports = __webpack_public_path__ + "static/media/logo-dark.b32e0b36.png";